import { useMutation } from '@tanstack/react-query';
import { generateNewKID, generateNewReviewKID } from './api.routes';

export function useGenerateNewKIDPdf() {
  return useMutation({
    mutationFn: (data: FormData) => generateNewKID(data),
  });
}

export function useGenerateNewReviewKIDPdf() {
  return useMutation({
    mutationFn: (data: FormData) => generateNewReviewKID(data),
  });
}
